import React, { useState, useEffect, useContext } from 'react';
import {
  ChatContainer,
  MessageList,
  Message,
  ConversationHeader,
  Avatar as ChatAvatar,
} from '@chatscope/chat-ui-kit-react';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import '../../../chatbot-settings/chat-interface/scss/chat-interface-overrides.scss';
import { getUserChats } from 'api-services/conversations';
import BotChatImg from 'assets/img/AvatarPlaceholder.svg';
import ChatBotContext from 'hooks/chat-bot-context';
import useLoading from 'hooks/use-loading';

const BOT = 'bot';
const ChatBox = ({ selectedConversation }) => {
  const [messages, setMessages] = useState([]); // REMOVE THIS SAMPLE DATA AFTER API INTEGRATION
  const { botName } = useContext(ChatBotContext);
  const {setLoading} = useLoading();

  useEffect(() => {
    if (selectedConversation?.conversation_id) getUserMessage();
  }, [selectedConversation]);

  const getUserMessage = async () => {
    try {
      setLoading(true);
      // Send API request and receive response
      const response = await getUserChats(selectedConversation?.conversation_id);
      if (response?.data) {
        setMessages(response?.data);
      } else {
        // Handle error if the API request is unsuccessful
        console.error('API request failed:', response.status, response.statusText);
      }
    } catch (error) {
      // Handle error if the API request encounters an exception
      console.error('API request error:', error);
    } finally{
      setLoading(false);
    }
  };

  return (
    <ChatContainer
      style={{
        height: '85vh',
        width: '100%',
      }}>
      <ConversationHeader>
        <ConversationHeader.Content
          userName={botName || 'Anonymous'}
          // info="Always here to help"
        />
        <ChatAvatar src={BotChatImg} name='AI BOT' />
      </ConversationHeader>
      <MessageList>
        {messages?.map((message) => (
          <Message
            key={message.entity_id}
            model={{
              message: message.content,
              sentTime: message.timestamp,
              sender: message.entity_type,
              direction: message.entity_type === BOT ? 'incoming' : 'outgoing',
            }}>
            {message.entity_type === BOT ? <ChatAvatar src={BotChatImg} name={message.entity_type} /> : <></>}
          </Message>
        ))}
      </MessageList>
    </ChatContainer>
  );
};

export default ChatBox;
